import axios from 'axios'

// const apiBaseUrl = (process.env.NODE_ENV === 'production')
//                     ? 'http://api.warnerconnects-audit.org'
//                     : 'http://localhost:3030'

const apiBaseUrl = process.env.VUE_APP_API_URL_BASE;
// const apiBaseUrl = 'https://api2.warnerconnects-audit.org' // process.env.VUE_APP_API_URL_BASE

// !! Netlify is erroring out when env variables are used for some reason

const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
  timeout: 300000, // 5 minutes, needed for large uploads
  headers: { 'Authorization': localStorage.jwt },
  // proxy: {
  //   host: 'http://feathers-api-app.feathersjs.com',
  //   port: 5000
  // },
});

// axiosInstance.apiCallsActive = () => Boolean(Object.keys(axiosInstance.defaults.activeApiCalls).length)

// axiosInstance.defaults.activeApiCalls = {}

// setup interceptors
// axiosInstance.interceptors.request.use(
//   async config => {
//     console.log("   request", config.baseURL, config.url)
//     axiosInstance.defaults.activeApiCalls[config.baseURL + config.url] = true
//     config.headers.Authorization = await localStorage.jwt;
//     return config;
//   },
//   error => Promise.reject(error)
// );

// axiosInstance.interceptors.response.use(
//   config => {
//     console.log("   response", config.config.url)
//     delete axiosInstance.defaults.activeApiCalls[config.config.url]
//     return config
//   }
// );

// setup Vue globals
export default axiosInstance